import Image from 'next/image';
import { Fragment } from 'react';

import { SearchModal } from '@/components/atomic/atoms';
import { staticMediaStoreBaseURL } from '@/config/common';

const HomeSearchBox = ({
  searchedValue,
  setShowSearchModal,
  showSearchModal
}) => (
  <Fragment>
    <div
      className='px-2.5 relative h-4.5 basic:h-5 xxxs:h-6.5 w-4.5 basic:w-5 xxxs:w-6.5 me-2 xxxs:me-3 md:me-4 md:hidden'
      onClick={() => setShowSearchModal(true)}
    >
      <Image
        alt='search'
        className='cursor-pointer'
        fill
        sizes='100vw'
        style={{ objectFit: 'cover' }}
        src={`${staticMediaStoreBaseURL}/icons/search_new.svg`}
      />
    </div>
    {showSearchModal && (
      <SearchModal
        {...{
          searchedValue,
          setShowSearchModal
        }}
      />
    )}
  </Fragment>
);

export default HomeSearchBox;
